import React from "react";
import fieldPropTypes from "../theme-prop-types";

const Tabs = ({
  selectedTabRef,
  variant = "td",
  titles,
  selected,
  onChange,
  invalid = false
}) => {
  if (titles.length === 1) {
    return (
      <div className='tabs-web-sdk'>
        <div className='tabs-title-web-sdk'>{titles[0]}</div>
      </div>
    );
  }

  const setInvalidClass = (title, index, isSelected) => {
    const active = index === isSelected;
    const hasTimeRegExp = /(pm|am)/i;
    const validDates = titles.filter(t => t.match(hasTimeRegExp)).length;

    if (invalid) {
      if (validDates === 1) {
        return !title.match(hasTimeRegExp) ? "invalid" : "";
      }

      if (validDates > 1) {
        const sameDateTabs = titles.filter(t => t === title).length;
        const lastSameDateIndex = titles.lastIndexOf(title);
        return (sameDateTabs > 1 && index === lastSameDateIndex) ||
          !title.match(hasTimeRegExp)
          ? "invalid"
          : "";
      }
      return !title.match(hasTimeRegExp) && active ? "invalid" : "";
    }
    return "";
  };

  return (
    /* eslint-disable react/no-array-index-key */
    <div className='tabs-web-sdk' ref={selectedTabRef}>
      {titles.map((title, index) => (
        <button
          key={index}
          data-testid={`tab-${index}`}
          className={`tab-${variant}-web-sdk ${
            index === selected ? "active" : ""
          } ${typeof title !== "string" ? "populated" : ""} ${setInvalidClass(
            title,
            index,
            selected
          )}`}
          type='button'
          onClick={() => onChange(index)}
        >
          <span className={`tab-label-${variant}-web-sdk`}>{title}</span>
        </button>
      ))}
    </div>
  );
};

Tabs.propTypes = fieldPropTypes;

export default Tabs;
